<template>
    <div class="userLogin">
        <!-- <div class="downApp" v-if="!appLoad">
            <van-button class="bu_tn" round block type="info" native-type="submit" @click="toLoad">下载激活软件</van-button>
        </div>
        <div class="wxMessenger" v-else>
            <img src="@/assets/down.png" alt="">
        </div> -->
        <div>
            <div class="big-img">
                <img src="./../../assets/kairan.jpg" alt="" class="yema-big-img">
            </div>
            <form>
                <br />
                <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="toLoad">下载激活软件</mt-button>
                </div>
                <br />
            </form>
        </div>

        <div class="wxMessenger" v-if="appLoad">
            <img src="@/assets/down.png" alt="">
        </div>

    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
    data() {
        return {
            appLoad: false,
        }
    },
    methods: {
        seeLoad() {
            this.$router.push('/user/AppASee')
        },
        toLoad() {
            var ua = window.navigator.userAgent.toLowerCase();
            //通过正则表达式匹配ua中是否含有MicroMessenger字符串
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.appLoad = true;
                return;
            }
            window.location.href = 'http://120.255.11.130:18080/app/app-release.apk'
        },

    },
    created() {
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.appLoad = true;
        } else {
            window.location.href = 'http://120.255.11.130:18080/app/app-release.apk'
        }
    }
}
</script>


<style scoped lang="less">
.wxMessenger {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background: #000;

    img {
        width: 100%;
    }
}

.big-img {
    text-align: center;
    padding: 2.5rem 0 1.5rem;
}

.yema-big-img {
    height: 200px;
}

#userLogin {


    .vant-input {
        /deep/ input[type=text] {
            background: #efefef;
            border-color: #efefef;
            border-radius: 20px;
            color: #999;
            text-align: center;
        }

        // /deep/ input[type=text]::-webkit-input-placeholder {
        // 	font-size: 12px;
        // 	text-align: center;
        // }
    }
}

.tabClick {
    color: #F44034;
    font-size: 1rem;
    position: absolute;
    bottom: 10%;
    left: 0;
    right: 0;
    text-align: center;
    margin: auto;
}

.formLine {
    .mint-button--primary {
        background: #24BAC8;
        border-radius: 20px;
        height: 44px;
    }
}

.formLine1 {
    .mint-button--primary {
        background: #33CC66;
        border-radius: 20px;
        height: 44px;
    }
}

// h2 {
//     display: flex;
//     align-items: center;
//     .yema-img {
//         height: 20px;
//         padding-right: 3px;
//     }
// }
</style>